exports.arc4 = '4px'
exports.arc8 = '8px'
exports.arc12 = '12px'
exports.arc20 = '20px'
exports.arc99999 = '99999px'
exports.circle = '50%'
